<div class="container">
    <div class="d-flex align-items-center mb-4">
        <h1 class="mb-0 me-3"><i class="far fa-gauge-high text-primary"></i> Dashboard</h1>
    </div>
    <div class="card round-corners heavy-shadow p-3 mb-3">

        <div class="row align-items-end gx-2" *ngFor="let f of filters; let idx = index">
            <div class="col-xl mb-3 mb-xxl-2 mobiscroll-select">
                <label class="form-label d-block">Top Level Account</label>
                <input mbsc-select id="filter-account-input" class="mobi-input form-control form-control-lg" [(ngModel)]="f.accountId" placeholder="Select Top Level Account" [data]="f.accounts" [mbscOptions]="f.selectOptions" />
            </div>
            <div class="col-xl mb-3 mb-xxl-2 mobiscroll-select">
                <label class="form-label d-block">Entity</label>
                <input mbsc-select id="filter-account-input2" class="mobi-input form-control form-control-lg" [(ngModel)]="f.entityIds" placeholder="Select Entity" [data]="f.entities" [mbscOptions]="f.parentOptions" />
            </div>
            <div class="col-xl-1 mb-3 mb-xxl-2 text-right">
                <button type="button" class="btn btn-outline-danger" (click)="removeEntity(idx)"><i class="far fa-trash-alt"></i></button>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="border-bottom my-3 pb-3">
                    <a href="javascript:void(0);" (click)="addEntity()"><i class="fa-regular fa-plus"></i> Add Entity Group</a>
                </div>
            </div>
        </div>
        <div class="row align-items-end gx-2">
            <div class="col-xl-6 mb-xxl-0">
                <label class="form-label d-block">Date Range</label>
                <input id="range" class="form-control form-control-lg mobi-input" placeholder="" mbsc-datepicker [mbscOptions]="dateOptions" [moment]="refToMoment" [(ngModel)]="dateRangeFilter" />
            </div>
        </div>
    </div>

    <div class="mt-4">
        <div class="fs-5 fw-bold mb-2">Download Reports</div>
        <div>
            <button type="button" class="btn btn-round btn-outline-secondary me-2 mb-2" (click)="downloadReport(pdxReportType.FormularyReport)"><i class="fa-regular fa-download"></i> Current Formulary Report</button>
            <button type="button" class="btn btn-round btn-outline-secondary me-2 mb-2" (click)="downloadReport(pdxReportType.POTransmissionReport)"><i class="fa-regular fa-download"></i> PO Transmission Report</button>
            <button type="button" class="btn btn-round btn-outline-secondary me-2 mb-2" (click)="downloadReport(pdxReportType.UsageReport)"><i class="fa-regular fa-download"></i> Usage Report</button>
            <button type="button" class="btn btn-round btn-outline-secondary me-2 mb-2" (click)="downloadReport(pdxReportType.UserComplianceReport)"><i class="fa-regular fa-download"></i> User Compliance Report</button>
            <button type="button" class="btn btn-round btn-outline-secondary me-2 mb-2" (click)="downloadReport(pdxReportType.VendorPerformanceReport)"><i class="fa-regular fa-download"></i> Vendor Performance Report</button>
            <button type="button" class="btn btn-round btn-outline-secondary me-2 mb-2" (click)="downloadReport(pdxReportType.VersioningReport)"><i class="fa-regular fa-download"></i> Versioning Report</button>
            <button type="button" class="btn btn-round btn-outline-secondary me-2 mb-2" (click)="downloadReport(pdxReportType.TransactionReport)"><i class="fa-regular fa-download"></i> Transactions Report</button>
            <button type="button" class="btn btn-round btn-outline-secondary me-2 mb-2" (click)="downloadReport(pdxReportType.DiscrepancyReport)"><i class="fa-regular fa-download"></i> Discrepancy Report</button>
        </div>
    </div>

</div>